import { useState } from "react";

export const useLocalStorage = (keyName, defaultValue) => {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const value = window.localStorage.getItem(keyName);
      if (value) {
        return value;
      } else {
        return defaultValue;
      }
    } catch (err) {
      return defaultValue;
    }
  });

  const setValue = (newValue) => {
    try {
      if (newValue !== null) {
        window.localStorage.setItem(keyName, newValue);
      } else {
        window.localStorage.removeItem(keyName);
      }
    } catch (err) {}
    setStoredValue(newValue);
  };
  return [storedValue, setValue];
};
